import { apiRoot } from "../../../old/beheer/store/api/apiRoot";
import { UrlBuilder } from "../../../utils/UrlBuilder";
import _ from "lodash";
import { BaseDocumentObject, ExistingResourceObject, QueryJsonApiIndex } from "./baseTypes";

const productJsonEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["Product"],
});

export type ProductAttributes = {
  naam: string;
  vestiging_id: number;
  sortkey: number | null;
  apiId1: string | null;
  apiId2: string | null;
  blocked: boolean;
  is_actief: boolean;
  prijs: number;
};

export type FilterFields =
  | "vestiging_id"
  | "category_id"
  | "product_id"
  | "option_group_id"
  | "apiId1"
  | "naam"
  | "id_naam_api_id_1";

export const productJsonApi = productJsonEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    fetchProductsJson: builder.query<
      BaseDocumentObject<ExistingResourceObject<ProductAttributes>>,
      QueryJsonApiIndex<FilterFields>
    >({
      query: ({ gridFilterItems, pagination, include }) => {
        return {
          url: new UrlBuilder("v2/products/query").addInclude(include).url,
          method: "POST",
          body: {
            per_page: pagination?.perPage,
            page: pagination?.page,
            filter: _.chain(gridFilterItems)
              .values()
              .keyBy("field")
              .mapValues((item) => (item?.value && Array.isArray(item.value) ? item.value.join(",") : item?.value))
              .value(),
          },
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "Product" as const, id })),
              { type: "Product", id: "PARTIAL-LIST" },
            ]
          : [{ type: "Product", id: "PARTIAL-LIST" }],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useFetchProductsJsonQuery, useLazyFetchProductsJsonQuery } = productJsonApi;
